import { api } from '../../../configs/api';
import { InputStateToken } from '@voltmoney/schema';
import { APP_CONFIG, AssetRepositoryMap, ConfigTokens, getAppHeader, } from '../../../configs/config';
import _ from 'lodash';
import SharedPropsService from '../../../SharedPropsService';
import { AnalyticsEventTracker } from '../../../configs/constants';
import { ROUTE } from '../../../routes';
import { ACTIONS } from './types';
import AsyncStorage from "@react-native-async-storage/async-storage";
let resendCount = 0;
export const fetchMyPortfolio = async (action, _datastore, { instrumentTrack, network, navigate, setDatastore, navigateWithClear, goBack }) => {
    const user = await SharedPropsService.getUser();
    const panNumber = user.linkedBorrowerAccounts[0].accountHolderPAN;
    const phoneNumber = user.linkedBorrowerAccounts[0].accountHolderPhoneNumber;
    const emailId = user.linkedBorrowerAccounts[0].accountHolderEmail;
    let applicationId = "";
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        applicationId = user.linkedApplications[0].applicationId;
    }
    instrumentTrack("GET_MF_PORTFOLIO_OTP_RESEND", { "getFolioFrom": action.payload.assetRepository, "attempt_count": resendCount });
    resendCount++;
    const response = await network.post(api.fetchInitV2, {
        applicationId: applicationId,
        emailId: emailId,
        panNumber: panNumber,
        phoneNumber: phoneNumber,
        assetRepository: action.payload.assetRepository,
    }, {
        headers: await getAppHeader(),
    });
    if (_.get(response, 'data.status') === 'SUCCESS') {
        await setDatastore(ROUTE.PLEDGE_VERIFY, "otpModalScreen", {
            state: InputStateToken.DEFAULT,
        });
    }
};
export const authCAS = async (action, _datastore, { navigate, setDatastore, network, analytics, showPopup, hidePopup, navigateWithClear, ...props }) => {
    const assetRepositoryType = await SharedPropsService.getAssetRepositoryType();
    if (action.payload.value.length !==
        AssetRepositoryMap.get(assetRepositoryType).OTP_LENGTH) {
        return;
    }
    await setDatastore(action.routeId, 'input', {
        state: InputStateToken.LOADING,
    });
    let applicationId = "";
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        applicationId = (await SharedPropsService.getUser())
            .linkedApplications[0].applicationId;
    }
    const response = await network.post(api.authCAS, {
        applicationId: applicationId,
        otp: action.payload.value,
        assetRepository: assetRepositoryType,
    }, { headers: await getAppHeader() });
    if (response.status === 200) {
        await analytics("eligibility_success", { "event": "eligibility_success" });
        /*** check available credit limit ***/
        const availableCreditAmount = _.get(response, 'data.stepResponseObject.availableCreditAmount', 0);
        /*** check max loan amount ***/
        const maxLoanAmount = _.get(response, 'data.stepResponseObject.maxLoanAmount', 0);
        /** set max loan amount in config ***/
        await SharedPropsService.setConfig(ConfigTokens.MAX_AMOUNT_ALLOWED, maxLoanAmount);
        if (availableCreditAmount > 0) {
            analytics(AnalyticsEventTracker.borrower_mf_pull['Event Name'], {
                ...AnalyticsEventTracker.borrower_mf_pull,
            });
            await SharedPropsService.setAuthCASResponse(response.data);
        }
        else {
            analytics(AnalyticsEventTracker.borrower_mf_pull_failed['Event Name'], {
                ...AnalyticsEventTracker.borrower_mf_pull_failed,
            });
        }
        await showPopup({
            autoTriggerTimerInMilliseconds: APP_CONFIG.POLLING_INTERVAL,
            isAutoTriggerCta: false,
            titleFont: false,
            title: 'Portfolio verified successfully',
            subTitle: 'Please click continue to proceed',
            type: 'SUCCESS',
            ctaLabel: 'Continue',
            primary: true,
            ctaAction: {
                type: ACTIONS.NAV_TO_FETCH,
                routeId: ROUTE.REFRESH_FETCH_OTP,
                payload: {}
            },
        });
        await setDatastore(action.routeId, "otpModalScreen", {
            state: InputStateToken.SUCCESS,
        });
    }
    else {
        await setDatastore(action.routeId, "otpModalScreen", {
            state: InputStateToken.ERROR,
        });
    }
};
export const goBack = async (action, _datastore, { goBack }) => {
    goBack();
};
export const navToFetch = async (action, _datastore, { navigateWithClear }) => {
    navigateWithClear(ROUTE.PLEDGE_CONFIRMATION);
};
